import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import {
  Grid,
  GridDetailRow,
  GridToolbar,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import React from "react";
import Images from "../../../Assets/Images";
import Api from "../../../Services/Api";
import "../../../Styles/AddRisks.scss";
import { toastr } from "react-redux-toastr";
import { Popup } from "@progress/kendo-react-popup";
import MitigationNameCell from "./MitigationNameCell";

export default class QualitativeImpact extends GridDetailRow {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      data: [],
      editID: null,
      openDeleteModelFlagView: false,
      probabilityColumns: [],
      dynamicHeatmapProbabilityRange: [],
      heatmapCount: "",
    };
  }

  componentDidMount() {
    this.init();
  }
  init = async () => {
    await this.getHeatmapConfiguration();
    this.getImpactTableList();
  };
  getHeatmapConfiguration = async () => {
    try {
      let arr = this.props.dynamicHeatmapProbabilityRange
        ? this.props.dynamicHeatmapProbabilityRange
        : [];
      let rangeArray = [];
      arr = arr?.map((item) => {
        item[item.fullDescription] = item.probabilityRangeValue;
        return item;
      });
      rangeArray = arr.map((column, index) => (
        <Column
          key={index}
          field={column.fullDescription}
          //title="(Very Low = 1) Description *"
          title={
            "( " +
            column.fullDescription +
            " = " +
            (index + 1) +
            ") Description"
          }
          width="120px"
          editor="text"
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} />
          )}
        />
      ));
      this.setState({
        dynamicHeatmapProbabilityRange:
          this.props.dynamicHeatmapProbabilityRange,
        probabilityColumns: rangeArray,
        heatmapCount: this.props.heatmapCount,
      });
      console.log("heatmapCount", this.props.heatmapCount);
    } catch (error) {
      console.error(error);
    }
  };
  getFieldName = (orderId) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.orderId === orderId
    );
    return obj?.fullDescription;
  };
  dynamicCols = (data) => {
    try {
      data.map((res) => {
        res.qualitativeImpactValue.map((item) => {
          let field = this.getFieldName(item.orderId);
          res[field] = item.qualitativeValue;
        });
      });
    } catch (error) {
      console.error(error);
    }
  };

  getImpactTableList = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      var req = {};
      let response = await Api.qualitativeGet(req);
      if (response.status === 200 && response.dynamicQualitativeImpact) {
        await this.dynamicCols(response.dynamicQualitativeImpact);
        this.setState({
          data: response.dynamicQualitativeImpact,
          loader: false,
        });
        console.log("response", response);
      } else {
        this.setState({ data: [], loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  addRecord = () => {
    const { data } = this.state;
    const newRecord = {};
    this.setState({
      data: [newRecord, ...data],
      editID: newRecord.id,
    });
  };
  discard = () => {
    const data = [...this.state.data];
    data.splice(0, 1);
    this.setState({ data });
  };

  cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];

    const additionalProps =
      cellField && cellField === inEditField
        ? {
            ref: (td) => {
              const input = td && td.querySelector("input");
              const activeElement = document.activeElement;

              if (
                !input ||
                !activeElement ||
                input === activeElement ||
                !activeElement.contains(input)
              ) {
                return;
              }

              if (input.type === "checkbox") {
                input.focus();
              } else {
                input.select();
              }
            },
          }
        : {
            onClick: () => {
              this.enterEdit(dataItem, cellField);
            },
          };
    if (tdElement && tdElement.props) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps },
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  rowRender = (trElement) => {
    const trProps = {
      ...trElement.props,
      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            this.exitEdit();
          });
        }
        // if (
        //   this.state.currentChangedValue &&
        //   this.state.currentChangedValue.id
        // ) {
        //   this.updateRecord(this.state.currentChangedValue);
        // }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };

  enterEdit = (dataItem, field) => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit: item.id === dataItem.id ? field : undefined,
    }));
    this.setState({
      data: dataValue,
      currentChangedValue: dataItem,
      editField: field,
    });
  };
  impactvalidation = (impactThresholdValue) => {
    let errortoaster = false;
    for (var i = 0; i < impactThresholdValue.length; i++) {
      if (impactThresholdValue[i].QualitativeValue?.length === 0) {
        errortoaster = true;
        return errortoaster;
      }
    }
  };
  exitEdit = () => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    this.setState({
      data: dataValue,
    });
  };

  isValidation = (dataItem) => {
    let flag = false;
    if (dataItem.name && dataItem.name.trim() && dataItem.name != "") {
      flag = true;
    }
    return flag;
  };

  validateImpactName = (dataItem) => {
    if (!dataItem.name.match(/^[a-zA-Z0-9\s]*$/)) {
      return false;
    }
    return true;
  };
  updateRecord = async (dataItem) => {
    try {
      if (!this.isValidation(dataItem)) {
        toastr.error("Please fill the all qualitative fields");
        return;
      }
 if (dataItem.name.includes('.')) {
        toastr.error("Impact Name must not contain '.'");
        return;
      }
      this.setState({ ...this.state, loader: true, currentChangedValue: {} });
      let name = dataItem.name.trim();
      let id = dataItem.id;
      delete dataItem["name"];
      delete dataItem["id"];
      delete dataItem["qualitativeImpactValue"];
      delete dataItem["inEdit"];
      let arr = [];
      var i = 1;
      for (let [key, value] of Object.entries(dataItem)) {
        arr.push({
          OrderId: this.getOrderId(key),
          QualitativeValue: value,
        });
        i++;
      }
      let errortoaster = this.impactvalidation(arr);
      if (errortoaster === true) {
        this.setState({ ...this.state, loader: false });
        dataItem["name"]=name;
        toastr.error("Please fill the all qualitative fields");
        return;
      }
      var request = {
        Name: name,
        id: id,
        QualitativeImpactValue: arr,
      };
      let response = await Api.qualitativeEdit(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          loader: false,
          currentChangedValue: {},
        });
        toastr.success(response.message);
        this.getImpactTableList();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  getOrderId = (field) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.fullDescription === field
    );
    return obj?.orderId;
  };
  isEmptyValidation = (dataArr) => {
    for(let i =0; i< dataArr.length;i++){
      if(dataArr[i].QualitativeValue === ""){
        return true;
      }
    }
    return false;
  };

  saveNewRecord = async (dataItem) => {
    try {
      if (!this.isValidation(dataItem)) {
        toastr.error("Please fill the all qualitative fields");
        return;
      }

 if (dataItem.name.includes('.')) {
        toastr.error("Impact Name must not contain '.'");
        return;
      }
      this.setState({ ...this.state, loader: true });
      let name = dataItem.name.trim();
      delete dataItem["name"];
      delete dataItem["inEdit"];
      let arr = [];
      var i = 1;
      for (let [key, value] of Object.entries(dataItem)) {
        arr.push({
          OrderId: this.getOrderId(key),
          QualitativeValue: value,
        });
        i++;
      }
      if ((arr.length  < this.state.heatmapCount) || this.isEmptyValidation(arr)) {
        this.setState({ ...this.state, loader: false });
        dataItem["name"]=name;
        toastr.error(" Please fill the all qualitative fields");
        return true;
      }
      

      var request = {
        Name: name,
        QualitativeImpactValue: arr,
      };
      let response = await Api.qualitativeAdd(request);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.getImpactTableList();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  
  openDeletePopup = (data) => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: true,
      impactId: data.id,
    });
  };
  closeDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: false,
    });
  };

  actionButtons = (event) => {
    let eventData = event.dataItem;
    return (
      <td className="editBtns">
        {eventData.id ? (
          <ul className="actionIcon">
            <li>
              <a
                title="Remove"
                onClick={() => this.openDeletePopup(eventData)}
                className="redbtn  icon"
              >
                <img src={Images.TRASH} width="10" alt="edit" />
              </a>
            </li>
          </ul>
        ) : (
          <ul className="actionIcon">
            <li>
              <a
                title="Save Action"
                className="greenbtn icon"
                onClick={() => this.saveNewRecord(eventData)}
              >
                <img src={Images.CHECKGREEN} width="10" alt="save" />
              </a>
            </li>
            <li>
              <a
                title="Discard"
                onClick={() => this.discard(eventData)}
                className="redbtn  icon"
              >
                <img src={Images.CLOSE} width="10" alt="edit" />
              </a>
            </li>
          </ul>
        )}
      </td>
    );
  };

  itemChange = (event) => {
    const changedValue = { ...event.dataItem, [event.field]: event.value };
    const dataValue = this.state.data.map((item) =>
      item.id === event.dataItem.id
        ? { ...item, [event.field]: event.value }
        : item
    );
    this.setState({
      ...this.state,
      currentChangedValue: changedValue,
      data: dataValue,
    });

    //dirty check
    let dirtData = this.state.data.find((item) => changedValue.id == item.id);
    if (
      dirtData &&
      changedValue[this.state.editField] == dirtData[this.state.editField]
    ) {
      this.exitEdit();
      return;
    } else if (changedValue.id) {
      this.updateRecord(changedValue);
    }
  };

  deleteThreshold = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      var requestParams = {
        DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        id: this.state.impactId,
      };
      let response = await Api.qualitativeDelete(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeDeletePopup();
        this.getImpactTableList();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };

  render() {
    return (
      <div>
        <div className="impactsHeader">
          <h4>Qualitative Variable</h4>
          <div className="addImpactrow">
            <button
              title="Add new"
              className="addthreshold"
              onClick={this.addRecord}
              style={{width:'126px'}}

            >
              Add
            </button>
          </div>
        </div>
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}

        <Grid
          data={this.state.data}
          cellRender={this.cellRender}
          rowRender={this.rowRender}
          reorderable
          resizable
          editField="inEdit"
          onItemChange={this.itemChange}
        >
          <Column
            title="Actions"
            cell={this.actionButtons}
            width="65px"
            locked={true}
          />
          <Column
            field="name"
            title="Name *"
            width="150px"
            locked={true}
            cell={(props) => (
              <MitigationNameCell {...props} onEditCell={this.enterEdit} />
            )}
          />
          {this.state.probabilityColumns}
        </Grid>

        <Popup
          show={this.state.openDeleteModelFlagView}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this Qualitative?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.deleteThreshold()}
                className="deleteBtn"
                type="button"
              >
                Delete
              </button>
              <button
                onClick={this.closeDeletePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
